const TYPE_PROPOSITION_VALUE = {
    ZTUDENT: 1,
    INSTRUCTOR: 2
}

export { TYPE_PROPOSITION_VALUE };